<template>
  <div>
    <header-top :headerText="headerText" showBack></header-top>
    <div class="basic-info">
      <div class="title">基本信息<span v-if="!isEdit" @click="isEdit = !isEdit">管理</span></div>
      <div class="basic" v-if="isEdit">
        <!-- 基本信息输入框 -->
        <el-form
          :model="information"
          :rules="informationRules"
          ref="information"
          label-width="6rem"
        >
          <div class="information">
            <el-form-item label="标题" prop="name" class="auto-height">
              <div class="item">
                <div class="input-form">
                  <el-input
                    v-model="information.name"
                    class="input"
                    placeholder="请输入标题"
                    clearable
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="摘要" prop="summary" class="auto-height">
              <div class="item">
                <div class="input-form">
                  <el-input
                    v-model="information.summary"
                    class="input"
                    placeholder="请输入资讯摘要"
                    type="textarea"
                    maxlength="200"
                    show-word-limit
                    resize="none"
                    clearable
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <div class="item">
                <div class="input-form">
                  <el-select
                    v-model="information.type"
                    placeholder="请选择资讯类型"
                    class="handle-select"
                  >
                    <el-option
                      v-for="item in typeDic"
                      v-show="item.isDefault"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="来源" prop="source">
              <div class="item">
                <div class="input-form">
                  <el-input
                    v-model="information.source"
                    class="input"
                    placeholder="请输入来源"
                    maxlength="30"
                    clearable
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="关键词" prop="keyWord" class="auto-height">
              <div class="item">
                <div class="input-form">
                  <el-input
                    v-model="information.keyWord"
                    class="input"
                    placeholder="请输入关键词"
                    maxlength="30"
                    clearable
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <div class="item">
                <div class="input-form">
                  <el-select
                    v-model="information.sort"
                    placeholder="请选择排序"
                    class="handle-select"
                  >
                    <el-option
                      v-for="item in 10"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="发布时间" prop="sort">
              <div class="item">
                <div class="input-form">
                  <el-date-picker
                    v-model="information.startTime"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </div>
              </div>
            </el-form-item>
          </div>
          <!-- 按钮 -->
          <div class="btn-group">
            <el-button type="primary" @click="submit('information')"
              >保存</el-button
            >
            <el-button @click="close">取消</el-button>
          </div>
        </el-form>
      </div>
      <div class="basic" v-else>
        <el-form
          :model="information"
          ref="information"
          label-width="6rem"
        >
          <div class="information">
            <el-form-item label="标题" prop="name" class="auto-height">
              {{ information.name |nullValue}}
            </el-form-item>
            <el-form-item label="摘要" prop="summary" class="auto-height">
              {{ information.summary|nullValue }}
            </el-form-item>
            <el-form-item label="类型" prop="type">
              {{ information.type|nullValue }}
            </el-form-item>
            <el-form-item label="来源" prop="source">
              {{ information.source|nullValue }}
            </el-form-item>
            <el-form-item label="关键词" prop="keyWord" class="auto-height">
              {{ information.keyWord|nullValue }}
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              {{ information.sort|nullValue }}
            </el-form-item>

            <el-form-item label="发布时间" prop="sort">
              {{ information.startTime|nullValue }}
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { getAdsSettings, getInformationSettings } from "@/http/api/system";
import { getInformation,updateInformation } from "@/http/api/information";
export default {
  components: {
    headerTop,
  },
  data() {
    //自定义表单验证人员列表
    var checkPeopleList = (rule, value, callback) => {
      if (value.length == 0) {
        return callback(new Error("请选择人员或岗位"));
      } else {
        callback();
      }
    };
    return {
      headerText: "管理资讯",
      id: this.$route.params.id,
      typeDic: {},
      isEdit:false,
      information: {
        //基本信息参数
        name: "",
        type: "",
        sort: 0,
        source: "",
        keyWord: "",
        summary: "",
        content: "",
        startTime: "",
        more: "",
        imageUrls:[]
      },
      submitLoading: false,
      //基本信息表单验证
      informationRules: {
        name: [
          { required: true, message: "请输入资讯名称", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getInformationSetting();
    this.getInformation() 
  },
  methods: {
    close(){
      this.isEdit = false;
      this.getInformation()
    },
    getInformation() {
      getInformation(this.id).then((res) => {
        //console.log();
        if (res && res.result) {
          this.information.name = res.result.name;
          this.information.type = res.result.type;
          this.information.sort = res.result.sort;
          this.information.source = res.result.source;
          this.information.keyWord = res.result.keyWord;
          this.information.summary = res.result.summary;
          this.information.content = res.result.content;
          this.information.startTime = res.result.startTime;
          this.information.more = res.result.more;
        }
      });
    },
    getInformationSetting() {
      getInformationSettings().then((res) => {
        res.result.map((item) => {
          //console.log(item, 111);
          if (item.name == "Deer.Information.Collection.InformationType") {
            this.typeDic = item.value;
          }
        });
      });
    },
    submit(formName) {
      this.submitLoading = true;
      if (formName) {
        this.$refs[formName].validate((valid) => {
          // var formData = new FormData();
          // formData.append("Information", JSON.stringify(this.information));
          updateInformation(this.id, this.information).then((res) => {
            if (res && res.result) {
              this.$message.success({
                message: "修改成功",
                showClose: true,
              });
              this.submitLoading = false;
              this.submitText = "保存";
              this.$router.go(-1);
            }
          });
        });
      } else {
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";

  @media (max-width: 1367px) {
    .basic-info {
      margin: 20px;
    }
  }

  @media (min-width: 1367px) and (max-width: 1920px) {
    .basic-info {
      margin: 20px 100px;
    }
  }

  @media (min-width: 1920px) {
   .basic-info {
      margin: 20px 180px;
    }
  }
.basic-info {
  text-align: initial;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
  .title {
    margin-bottom: 20px;
    span{
      float: right;
      font-size: 14px;
      color: $--color-primary;
      cursor: pointer;
      font-weight: 500;
    }
  }
  .information {
    ::v-deep .el-date-editor {
      width: 100%;
      .el-icon-date {
        left: 0;
      }
      .el-input__inner {
        padding-left: 30px;
      }
      .el-icon-circle-close {
        right: 0;
      }
    }
    .basic-head {
      .basic-head-item {
        display: flex;
        align-items: flex-end;
        margin-bottom: 8px;
        line-height: 0;

        .default-img,
        .basic-head-img {
          margin-right: 10px;
          width: 143px;
          height: 148px;
        }

        .upload-btn {
          border: 1px solid rgba(221, 221, 221, 1);
          width: 110px;
          height: 30px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
        }
      }
    }

    .item {
      @include flex(row, center);
      .input-form {
        width: 550px;
        .handle-select {
          width: 100%;
        }
      }
    }
    .item:last-child {
      padding-bottom: 0;
    }
    .tip {
      padding-top: 9px;
    }
  }
  .btn-group {
    border-top: 1px solid #ddd;
    padding-top: 20px;
  }

  .title {
    font-size: 14px;
    color: #000;
    font-weight: bold;
    padding-top: 6px;
  }
  /*管理信息-基本信息*/
  &.information {
    .title {
      padding-bottom: 24px;
    }
    .key {
      color: #888;
      padding-right: 11px;
      span {
        color: #e04f49;
      }
    }
  }
}

</style>
